import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import LineChart from "@/components/VueCharts/LineChart.vue";
import PieChart from "@/components/VueCharts/PieChart.vue";
import MixedChart from "@/components/VueCharts/MixedChart.vue";
import PolarAreaChart from "@/components/VueCharts/PolarAreaChart.vue";
import DoughnutChart from "@/components/VueCharts/DoughnutChart.vue";
import { ChartType } from "@/types/VueCharts/FactoryChart";
import BarChart from "@/components/VueCharts/BarChart.vue";
import { chartDefaultOptions } from "@/utils/chartDefaultOptions";
import ScatterPlotChart from "@/components/VueCharts/ScatterPlotChart.vue";
let ChartFactory = class ChartFactory extends Vue {
    charts;
    cols;
    md;
    get chartDefaultOptions() {
        return chartDefaultOptions;
    }
    isValidChart(type) {
        return Object.values(ChartType).includes(type);
    }
    colsOrDefault(cols) {
        return cols ?? 2;
    }
    rowsOrDefault(rows) {
        return rows ?? 1;
    }
};
__decorate([
    Prop({ required: true })
], ChartFactory.prototype, "charts", void 0);
__decorate([
    Prop({ default: () => 12 })
], ChartFactory.prototype, "cols", void 0);
__decorate([
    Prop({ default: () => 6 })
], ChartFactory.prototype, "md", void 0);
ChartFactory = __decorate([
    Component({
        components: {
            BarChart,
            LineChart,
            PieChart,
            MixedChart,
            PolarAreaChart,
            DoughnutChart,
            ScatterPlotChart,
        }
    })
], ChartFactory);
export default ChartFactory;
